const useHttpService = () => {
  const formatBodyData = (body?: SimpleObject) => JSON.stringify(body) || null;

  return {
    formatBodyData,
  };
};

export default useHttpService;
